import React from 'react';
import { connect } from 'react-redux';
import ModalActions from 'app/shared/actions/ModalActions';
import ModalConstants from 'app/shared/constants/ModalConstants';

const PropertyNameList = ({ invoice, dispatch }) => {
    const handlePropertyListClick = propertyList => dispatch(ModalActions.showModal({
        modalType: ModalConstants.CONSOLIDATED_PROPERTY_LIST_MODAL,
        propertyList,
        useModalDialog: false,
    }));
    if (!invoice.propertyNames) return '';
    if (invoice.propertyNames.length === 1) return invoice.propertyNames;
    return (
        <div
            onClick={() => handlePropertyListClick(invoice.propertyNames)}
            className="Utils-primary TableMFH-clickable"
        >
            {`${invoice.propertyNames.length} Properties`}
        </div>
    );
};

export default connect()(PropertyNameList);
